let language = {
    ORDERS_TITLE_EMPTY: "The sample orders is empty.",
    ORDERS_TITLE_TIPS: "No eligible orders, please try other search criteria.",
    ORDERS_TITLE_INVOICE: "BULK DOWNLOAD INVOICE",
    ORDERS_TITLE_OPERATION: "Operation",    
    ORDERS_TITLE_NAME: "Name",
    ORDERS_TITLE_TOTAL: "Total Price",
    ORDERS_TITLE_ORDER_STATUS: "Order Status",
    ORDERS_TITLE_OPTIONS: "Options",
    ORDERS_TITLE_CANCEL: "Cancel Order",
    ORDERS_TITLE_RETURN: "Return Request",
}

export { language }